// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fi5B","left":"styles_left__2JODm","desktopActions":"styles_desktopActions__q_QPr","title":"styles_title__4iYPd"};